<template>
    <div class="relative inline-block text-left">
        <div>
            <button
                type="button"
                @click="open = !open"
                class="inline-flex items-center px-1.5 py-1.5 border border-transparent text-xs font-medium rounded text-indigo-700 bg-indigo-100 hover:bg-indigo-200 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500"
            >
                <svg class="w-4 h-4" fill="currentColor" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg">
                    <path
                        d="M9 2a2 2 0 00-2 2v8a2 2 0 002 2h6a2 2 0 002-2V6.414A2 2 0 0016.414 5L14 2.586A2 2 0 0012.586 2H9z"
                    ></path>
                    <path d="M3 8a2 2 0 012-2v10h8a2 2 0 01-2 2H5a2 2 0 01-2-2V8z"></path>
                </svg>
                <SlideOver :title="$t('messages.duplicate_programming')" :show="open" @close="open = false">
                    <div>
                        <form :action="programming.links.duplicate" method="post" @submit.prevent="submit">
                            <div class="sm:col-span-4">
                                <div class="mt-1">
                                    <FormLabel :value="$t('messages.title')" for="title" />
                                    <FormInput
                                        required
                                        id="title"
                                        v-model="form.title"
                                        name="title"
                                        type="text"
                                        max="191"
                                        class="mt-1 w-full"
                                    />
                                    <FormError :value="form.errors.title" class="mt-2" />
                                </div>
                            </div>

                            <div class="sm:col-span-4">
                                <div class="mt-1">
                                    <FormLabel :value="$t('messages.trimester')" for="trimester" />
                                    <FormSelect
                                        required
                                        id="trimester"
                                        v-model="form.trimester"
                                        :options="options.trimesters"
                                        class="mt-1 w-full"
                                    />
                                    <FormError :value="form.errors.trimester" class="mt-2" />
                                </div>
                            </div>

                            <div class="sm:col-span-4">
                                <FormLabel :value="$tc('messages.grade_levels', 2)" for="grade_level_id" />
                                <div class="mt-1 flex flex-wrap gap-2">
                                    <label v-for="gradeLevel in gradeLevels" :key="gradeLevel.value">
                                        <input
                                            type="checkbox"
                                            name="grade_levels[]"
                                            v-model="form.grade_level_ids"
                                            :value="gradeLevel.value"
                                            :id="gradeLevel.value"
                                            class="focus:ring-indigo-500 h-4 w-4 text-indigo-600 border-gray-300 rounded mr-1"
                                        />
                                        {{ gradeLevel.text }}
                                    </label>
                                </div>
                                <FormError :value="form.errors.grade_level_id" class="mt-2" />
                                <div>
                                    <pre>{{ form.grade_level_id }}</pre>
                                </div>
                            </div>

                            <div class="mt-5">
                                <FormCheckbox v-model="form.copy_activities">
                                    {{ $t('messages.copy_activities') }}
                                </FormCheckbox>
                                <FormError :value="form.errors.copy_activities" class="mt-2" />
                            </div>

                            <AlertMessage class="mt-5" :class="form.copy_activities ? 'visible' : 'invisible'">
                                <template v-slot:title>
                                    {{ $t('messages.warning') }}
                                </template>
                                <template v-slot:body>
                                    {{ $t('messages.all_activities_will_be_copied') }}
                                </template>
                            </AlertMessage>

                            <div class="flex justify-end mt-5 space-x-2">
                                <div>
                                    <FormCheckbox v-model="form.confirmation">
                                        {{ $t('messages.are_you_sure?') }}
                                    </FormCheckbox>
                                    <FormError :value="form.errors.confirmation" class="mt-2" />
                                </div>

                                <div>
                                    <AppButton
                                        desired-action
                                        element="button"
                                        type="submit"
                                        :disabled="form.processing"
                                    >
                                        {{ $t('messages.save') }}
                                        <span v-if="form.processing" class="ml-1 btn-spinner"></span>
                                    </AppButton>
                                </div>
                            </div>
                        </form>
                    </div>
                </SlideOver>
            </button>
        </div>
    </div>
</template>

<script>
import SlideOver from '@/components/SlideOver.vue';
import FormLabel from '@/components/Forms/FormLabel.vue';
import FormSelect from '@/components/Forms/FormSelect.vue';
import FormError from '@/components/Forms/FormError.vue';
import FormInput from '@/components/Forms/FormInput.vue';
import AppButton from '@/components/AppButton.vue';
import AlertMessage from '@/components/AlertMessage.vue';
import FormCheckbox from '@/components/Forms/FormCheckbox.vue';

export default {
    name: 'DuplicateProgrammingPanel',
    components: {
        AppButton,
        SlideOver,
        FormLabel,
        FormSelect,
        FormError,
        FormInput,
        AlertMessage,
        FormCheckbox,
    },
    props: ['options', 'programming'],
    data() {
        return {
            open: false,
            form: this.$inertia.form({
                title: this.programming.title,
                trimester: this.programming.trimester,
                grade_level_ids: this.programming.grade_level_ids,
                confirmation: false,
                copy_activities: true,
            }),
        };
    },
    methods: {
        submit() {
            this.form.post(this.programming.links.duplicate);
        },
    },
    computed: {
        gradeLevels() {
            return this.options.grade_levels.filter((g) => g.stage_id == this.programming.stage_id);
        },
    },
};
</script>
